import { Navigate, useLocation } from 'react-router-dom';
import { isLoggedIn } from '../utils/session';

export default function ProtectedRoute({ children, roles }) {
  const location = useLocation();

  if (!isLoggedIn()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (roles && roles.length > 0) {
    const r = sessionStorage.getItem('sangramUserRole');
    if (!roles.includes(r)) {
      return <Navigate to="/login" replace />;
    }
  }

  return children;
}
